import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Dropdown, Button, ButtonGroup } from "react-bootstrap";
import { get_branch_data } from "../../../services/employeeApi";
import { useQuery } from "@tanstack/react-query";
import SharedModal from "../../../components/UiComponent/SharedContentModal";
import BasicTable from "../../../components/UiComponent/customTable";
import { GrView, GrStatusGoodSmall } from "react-icons/gr";
import AddBranchForm from "./addBranch";
import ChangeBranchManager from "./changeBranchManager";
import UpdateBranch from "./updateBranch";
import { GetUserInfo, hasAccess } from "../../../utils/permissionChecker";
import { FaEdit, FaUserCog } from "react-icons/fa";
const Branch = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const user = GetUserInfo();
  const getEmployeetQuery = useQuery(["branch"], () => get_branch_data());
  const [showModal, setShowModal] = useState(false);
  const [managerChangeModal, setmanagerChangeModal] = useState(false);
  const ShowmanagerChangeModal = () => setmanagerChangeModal(true);
  const ClosemanagerChangeModal = () => setmanagerChangeModal(false);
  const [BranchUpdateModal, setBranchUpdateModal] = useState(false);
  const ShowBranchUpdateModal = () => setBranchUpdateModal(true);
  const CloseBranchUpdateModal = () => setBranchUpdateModal(false);
  const [branchId, setBranchId] = useState();
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const employeeData = useMemo(() => {
    return getEmployeetQuery.data || [];
  }, [getEmployeetQuery.data]);

  if (getEmployeetQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (getEmployeetQuery.isError) {
    return <div>Error: {getEmployeetQuery.error.message}</div>;
  }
  const handleViewBranch = (branchId) => {
    const { accessRole, employee } = user || {};
    const canAccess =
      accessRole === "administrator" || branchId === employee?.branch_id;
    if (canAccess) {
      history.push("/branch-view", { branchId });
    } else {
      alert("You do not have access to this branch.");
    }
  };
  const openAssignProjectModal = (event, id) => {
    event.preventDefault();
    handleShowModal();
    setBranchId(id);
  };
  const openBranchUpdateModal = (event, id) => {
    event.preventDefault();
    ShowBranchUpdateModal();
    setBranchId(id);
  };
  const openmanagerChangeModal = (event, id) => {
    event.preventDefault();
    ShowmanagerChangeModal();
    setBranchId(id);
  };
  const handleButtonSubmit = () => {
    handleCloseModal();
  };
  const managerChangeSubmit = () => {
    ClosemanagerChangeModal();
  };
  const BranchUpdateSubmit = () => {
    CloseBranchUpdateModal();
  };
  const employeeColumns = [
    {
      header: "name",
      accessorFn: (row) => `${row.name}`,
    },
    {
      header: "phone",
      accessorKey: "phone",
    },
    {
      header: "location",
      accessorKey: "location",
    },
    {
      header: "Manager",
      accessorFn: (row) => {
        const firstName = row.manager?.first_name || "not assigned";
        const fatherName = row.manager?.father_name || "";
        return `${firstName} ${fatherName}`.trim();
      },
    },
    {
      header: "action",
      accessor: "id",
      cell: (row) => (
        <>
          <GrStatusGoodSmall
            style={{
              color: row.row.original.status !== true ? "red" : "green",
            }}
          />
          {hasAccess(["administrator"], user.accessRole) ? (
            <Dropdown as={ButtonGroup} size="sm">
              <Dropdown.Toggle variant="primary" id="dropdown-basic" size="sm">
                Actions
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => handleViewBranch(row.row.original.id)}
                >
                  <GrView style={{ marginRight: "5px" }} />
                  View
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={(e) => openBranchUpdateModal(e, row.row.original)}
                >
                  <FaEdit style={{ marginRight: "5px" }} />
                  Update
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={(e) => openmanagerChangeModal(e, row.row.original)}
                >
                  <FaUserCog style={{ marginRight: "5px" }} />
                  Change Manager
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            ""
          )}
        </>
      ),
    },
  ];
  return (
    <div>
      {hasAccess(["administrator", "manager"], user.accessRole) ? (
        <BasicTable
          data={employeeData}
          columns={employeeColumns}
          title={`branch_list`}
          actionButton={
            hasAccess(["administrator"], user.accessRole) ? (
              <Button
                variant="btn btn-info btn-sm"
                onClick={(e) => openAssignProjectModal(e, "000")}
              >
                {t("add_branch")}
              </Button>
            ) : (
              ""
            )
          }
        />
      ) : null}
      <SharedModal
        show={showModal}
        title="add_new_branch"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <AddBranchForm
            onSubmitButton={handleButtonSubmit}
            parentID={branchId}
          />
        }
      />
      <SharedModal
        show={managerChangeModal}
        title="change_branch_manager"
        onHide={ClosemanagerChangeModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <ChangeBranchManager
            onSubmitButton={managerChangeSubmit}
            parentID={branchId}
          />
        }
      />
      <SharedModal
        show={BranchUpdateModal}
        title="update_branch_info"
        onHide={CloseBranchUpdateModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <UpdateBranch
            onSubmitButton={BranchUpdateSubmit}
            parentID={branchId}
          />
        }
      />
    </div>
  );
};
export default Branch;
